<template>
    <div>
        <div class="editor-container">
            <textarea class="editor" v-model="exp"  @change="getExp" :maxlength="maxlength" 
            :show-word-limit="maxlength>0" ref="textarea"></textarea>
            <div class="operator">
                <a v-if="noDisplay.indexOf('AND') === -1" @click="addingOperator(' AND ')">AND</a>
                <a v-if="noDisplay.indexOf('OR') === -1" @click="addingOperator(' OR ')">OR</a>
                <a v-if="noDisplay.indexOf('NOT') === -1" @click="addingOperator(' NOT ')">NOT</a>
                <a v-if="noDisplay.indexOf('(') === -1" @click="addingOperator('(')">(</a>
                <a v-if="noDisplay.indexOf(')') === -1" @click="addingOperator(')')">)</a>
                <a v-if="noDisplay.indexOf('XOR') === -1" @click="addingOperator(' XOR ')">XOR</a>
                <a v-if="noDisplay.indexOf('ADJ') === -1" @click="addingOperator(' ADJ ')">ADJ</a>
                <a v-if="noDisplay.indexOf('EQU/10') === -1" @click="addingOperator(' EQU/10 ')">EQU/10</a>
                <a v-if="noDisplay.indexOf('XOR/10') === -1" @click="addingOperator(' XOR/10 ')">XOR/10</a>
                <a v-if="noDisplay.indexOf('PRE/10') === -1" @click="addingOperator(' PRE/10 ')">PRE/10</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'ipLogicSearch',
    props: {
        existExp: {
            type: String,
            default: ''
        },
        appendExp: {
            type: String,
            default: ''
        },
        maxlength: {
            type: Number,
            default:100000
        },
        noDisplay:{
            type:Array,
            default(){
                return []
            }
        }
    },
    watch: {
        appendExp(val) {
            this.exp += val;
            this.$emit('getExp', this.exp);
        },
        existExp(val){
            this.exp = val; 
            this.$emit('getExp', this.exp);
        }
    },
    data(){
        return{
            exp:''
        }
    },
    mounted(){
        this.exp = this.existExp;
    },
    methods:{
        getExp(){
            this.$emit('getExp', this.exp);
        },
        addingOperator(operator){
            var textareaField = this.$refs.textarea;
            if(document.selection){
                textareaField.focus();
                var sel = document.selection.createRange();
                sel.text = operator;
                sel.select();
            }else if(textareaField.selectionStart || textareaField.selectionStart == '0'){
                var startPos = textareaField.selectionStart;
                var endPos = textareaField.selectionEnd;
                var restoreTop = textareaField.scrollTop;
                this.exp = this.exp.substring(0,startPos)+operator+this.exp.substring(endPos,this.exp.length);
                if(restoreTop > 0){
                    textareaField.scrollTop = restoreTop;
                }                
            }else{                
                this.exp += operator;
            }
            this.$emit('getExp', this.exp);
        }
    }
}
</script>
<style lang="scss" scoped>
 .editor-container {
        overflow: auto;
        border: 1px solid #cccccc;
        .editor {
          font-family: 'Microsoft Yahei';
          width: 100%;
          height: 190px;
          border: none;
          outline: none;
          overflow: auto;
          padding: 8px;
          resize: none;
          box-sizing: border-box;
        }
        .operator {
          float: right;
          padding-right: 8px;
          a {
            display: inline-block;
            color: #333333;
            margin: 6px 8px;
            text-decoration: none;
            font-size: 12px;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
</style>




